export const DEFINE_MODULE = {
  name: "Sĩ số",
  fields: "class-numbers"
}
